import { createSlice } from "@reduxjs/toolkit";
import { fetchAllProducts } from "../actions/AllProductsAction";

const productsSlice = createSlice({
  name: "products",
  initialState: {
    products: [], 
    pagination: {}, 
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default productsSlice.reducer;
